/**
 * BasicInfoTab — Campus details display.
 */

import { Link } from 'react-router-dom';
import { formatPhone, convertIsoToLocal } from '../../../../../libs.jsx';

const BasicInfoTab = ({
  campusData, corporateName, corporateId, timezoneName,
  editRights, onEdit,
}) => {
  return (
    <>
      {/* Campus Details */}
      <div className="pp-section">
        <div className="pp-section__header">
          <h3 className="pp-section__title">Campus Details</h3>
          <div className="pp-section__actions">
            {editRights && (
              <button className="dp-btn dp-btn--secondary dp-btn--sm" onClick={onEdit}>
                ✎ Edit
              </button>
            )}
          </div>
        </div>
        <div className="pp-section__body">
          <div className="pp-field-grid">
            <div className="pp-field">
              <span className="pp-field__label">Campus ID</span>
              <span className="pp-field__value">{campusData?.campus_id || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Campus GUID</span>
              <span className="pp-field__value pp-field__value--mono">
                {campusData?.campus_guid || '—'}
              </span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Campus Name</span>
              <span className="pp-field__value">{campusData?.campus_name || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Corporation</span>
              <span className="pp-field__value">
                {corporateId ? (
                  <Link to={`/profiles/corporate/${corporateId}`} className="pp-field__link">
                    {corporateName || `Corp #${corporateId}`}
                  </Link>
                ) : (
                  '—'
                )}
              </span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Street Address</span>
              <span className="pp-field__value">{campusData?.campus_street_address || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Country</span>
              <span className="pp-field__value">{campusData?.campus_country || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">City</span>
              <span className="pp-field__value">{campusData?.campus_city || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">State</span>
              <span className="pp-field__value">{campusData?.campus_state || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Zip Code</span>
              <span className="pp-field__value">{campusData?.campus_zip || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Timezone</span>
              <span className="pp-field__value">{timezoneName || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Email</span>
              <span className="pp-field__value">{campusData?.campus_email || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Phone</span>
              <span className="pp-field__value">
                {campusData?.campus_phone ? formatPhone(campusData.campus_phone) : '—'}
              </span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Latitude</span>
              <span className="pp-field__value">{campusData?.campus_latitude || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Longitude</span>
              <span className="pp-field__value">{campusData?.campus_longitude || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Service Plan Expiry</span>
              <span className="pp-field__value">
                {campusData?.date_service_plan_expire
                  ? convertIsoToLocal(campusData.date_service_plan_expire)
                  : '—'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicInfoTab;
